import React from "react";
import { useIntl } from "react-intl";

import styles from "./Loader.module.scss";

import Spinner from "./Spinner";
import { Typography } from "antd";

function Loader(props) {
    const intl = useIntl();

    return (
        <div className={styles.main}>
            <div className={styles.content}>
                <Spinner />
                <Typography.Title>
                    {intl.formatMessage({ id: "global.presentation.loader.title" })}
                </Typography.Title>
            </div>
        </div>
    );
}


export default Loader;